import { ConflictError } from "./conflict-error";

// Thrown when the shelf scanned at the rack is not one this article is assigned to.
//
// A put-away is confirmed by scanning the shelf the material actually went onto, and that scan is
// allowed to disagree with the destination the leg was raised for — the person is standing at the
// rack and the label in their hand is better information than the least-balance guess made at the
// gate. What it may not do is invent an assignment: an article stands where the warehouse says it
// stands, and accepting any shelf at all would let a put-away silently create the layout.
//
// So a scan of a shelf the article is assigned to re-targets the leg, and a scan of any other
// shelf is this refusal. 409 rather than 400: the code is a real label and the caller may read it,
// and what is missing is the assignment. Assigning the location first is the fix, and it holds for
// every return afterwards.
export class ShelfNotAssignedToArticleError extends ConflictError {
	constructor() {
		super("stock.shelf_not_assigned_to_article");
		this.name = "ShelfNotAssignedToArticleError";
	}
}
